import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { useLogout } from '../../hooks';
export const LogoutLink = () => {
    const logout = useLogout();
    return (React.createElement("a", { onClick: logout }, COPY_SPECIFIC.LOGOUT));
};
